<template>
    <div
      v-if="isVisible"
      class="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50"
    >
      <div class="relative bg-white rounded-lg shadow-lg max-w-xl w-full p-12">
        <!-- Close button -->
        <button
          @click="closePopup"
          class="absolute top-6 right-8 text-gray-800 hover:text-gray-600"
        >
          <i class="pi pi-times" style="font-size: 0.75rem"></i>
        </button>
  
        <div class="flex flex-col items-center justify-content gap-12">
          <!-- SVG Icon -->
          <div class="mb-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="106"
              height="105"
              viewBox="0 0 106 105"
              fill="none"
            >
              <path
                d="M58.9105 16.4965L94.7827 78.7869C97.297 83.1756 94.0486 88.5938 88.8724 88.5938H17.1278C11.9517 88.5938 8.70323 83.1756 11.2175 78.7869L47.0898 16.4965C49.6737 12.0012 56.3265 12.0012 58.9105 16.4965Z"
                stroke="#F25F25"
                stroke-width="4.2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M53 59.0625V42.6562"
                stroke="#F25F25"
                stroke-width="4.2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M53 77.1094C54.8122 77.1094 56.2813 75.6403 56.2813 73.8281C56.2813 72.0159 54.8122 70.5469 53 70.5469C51.1878 70.5469 49.7188 72.0159 49.7188 73.8281C49.7188 75.6403 51.1878 77.1094 53 77.1094Z"
                fill="#F25F25"
              />
            </svg>
          </div>
  
          <!-- Title -->
          <h2 class="text-2xl font-semibold mb-2 text-center">
            Payment Failed! Please try again or reach out to our help center for
            assistance.
          </h2>
          <!-- Buttons - Changed justify-center to justify-end -->
          <div class="flex justify-end gap-4 w-full">
            <button
              @click="goBack"
              class="px-6 py-2.5 border border-solid border-gray-300 text-gray-700 rounded-md hover:bg-gray-50 transition-colors"
            >
              Go Back to Campaigns
            </button>
            <button
              @click="retryPayment"
              class="px-6 py-2.5 bg-[#369DA3] text-white rounded-md hover:bg-teal-800 transition-colors flex items-center gap-2"
            >
              <i class="pi pi-plus" style="font-size: 0.75rem"></i>
              Retry Payment
            </button>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import store from "../../store";
  import router from "../../router/router";
  export default {
    data() {
      return {
        isVisible: true,
      };
    },
    methods: {
      closePopup() {
        this.isVisible = false;
      },
      goBack() {
        this.$emit('closePopup', 'paymentStatusfalid');
        this.$router.push('/campaigns');
      },
      retryPayment() {
        this.$emit('closePopup', 'paymentStatusfalid');
        store.commit('openReviewPayment')
      },
    },
  };
  </script>
  
  <style>
  .parent-div {
    position: relative;
  }
  </style>
  